module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7a6a5c794d6fe77611613ddfdf905506.png";